import { Grid } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";

import PSCLogo from "../../Assets/Logo/PSCLogo.jpg";
import {
  formatDate,
  FormatDay,formatTimeRange
} from "../../Components/Helpers/DateTimeConverter";
import { GetPublicURL, PostMethod, GetMethod } from "../../Helper/api";
import { useParams,useLocation } from "react-router-dom";
import { GreenColorButton } from "../../Components/MaterialButtonStyle/StyleButton";
import LoaderModal from "../../Components/Modal/Loader"
const CallLetterView = () => {
  const targetRef = useRef();
  const params = useParams();
  const location = useLocation();
  const [profileImage, setprofileImage] = useState();
  const [CharmanSignature, setCharmanSignature] = useState();
  const [postName, setpostName] = useState();
  const [callLetterName, setcallLetterName] = useState();
  const [CandidateDetail, setCandidateDetail] = useState();
  const [applicationDetail, setapplicationDetail] = useState();
  const [LetterHeading, setCallLetterHeading] = useState();
  const [CharmanName, setCharmanName] = useState();
  const [ShowLoader, setShowLoader] = useState(false);
  const [CenterInformations, setCenterInformations] = useState();
  const [ShiftDetails, setShiftDetails] = useState();
  

  useEffect(() => {
    
    if (applicationDetail?.applicant_image) {
      AdminConvertbase64(applicationDetail.applicant_image);
    }

    if(String(location.pathname).includes("physical") ){
      setcallLetterName("Physical")
      setCallLetterHeading("Physical Test Call Letter")
    }else if(String(location.pathname).includes("medical") ){
      setcallLetterName("Medical")
      setCallLetterHeading("Medical Test Call Letter")
    }else{
      setcallLetterName("Computer")
      setCallLetterHeading("Computer Based test Call Letter")
    }

  }, [CandidateDetail]);
  useEffect(() => {
    GetCharmenSignatures();
    if (params?.id) {
      GetApplicationDetails(params.id);
    }
  
  }, []);
  const GetCharmenSignatures = async () => {
    try {
      let url = "settings/signatureslist";
      let method = "GET";
      const response = await GetMethod({ url, method });
      if (response.status) {
       
        if (response.result[0].signature_file) {
          AdminConvertbase642(response.result[0].signature_file);
        }
        setCharmanName(response.result[0].signature_name);
      }
    } catch (Error) {
      console.log("Error in GetCharmenSignatures", Error);
    }
  };
  const GetApplicationDetails = async (id) => {
    try {
      let url = "test/viewapplications";
      let method = "POST";
      let params = {
        job_application_uuid: id,
      };
      setShowLoader(true)
      const response = await PostMethod({ url, method, params });
      if (response.status) {
  
        if (response?.jobapplication[0]) {
          setapplicationDetail(response.jobapplication[0]);
          setpostName(response.jobapplication[0].job_name);
          if(String(location.pathname).includes("physical") ){
            setCenterInformations(response.physicaltest[0]);
            if(response.physicaltest[0].shift_id){
              let shift_details=[]
              response.physicaltest[0]?.shift_details?.map((row,index)=>{
                if(index+1 ==response.physicaltest[0].shift_id){
                  shift_details = row
                }
              })
              setShiftDetails(shift_details)
            }
          }else if(String(location.pathname).includes("medical") ){
            setCenterInformations(response.medicaltest[0]);
            if(response.medicaltest[0].shift_id){
              let shift_details=[]
              response.medicaltest[0]?.shift_details?.map((row,index)=>{
                if(index+1 ==response.medicaltest[0].shift_id){
                  shift_details = row
                }
              })
              setShiftDetails(shift_details)
            }
          }else if(String(location.pathname).includes("computer") ){
            setCenterInformations(response.computertest[0]);
            if(response.computertest[0].shift_id){
              let shift_details=[]
              response.computertest[0]?.shift_details?.map((row,index)=>{
                if(index+1 ==response.computertest[0].shift_id){
                  shift_details = row
                }
              })
           
              setShiftDetails(shift_details)
            }
          }
        }
        if (response.jobapplication[0]?.applicant_temp_details) {
          let data = response.jobapplication[0]?.applicant_temp_details;
          const formattedArray = [
            data.reduce((result, item) => {
              const sanitizedKey = item.name.replace(/\s+/g, ""); // Remove spaces from the key
              result[sanitizedKey] = item.value; // Assign the value to the sanitized key
              return result;
            }, {}),
          ];
          setCandidateDetail(formattedArray[0]);
        }
        setShowLoader(false)
      }else{
        setShowLoader(false)
      }
    } catch (Error) {
      setShowLoader(false)
      console.log("Error", Error);
    }
  };
  const AdminConvertbase64 = async (image) => {
    try {
      let images = await GetPublicURL(image);
      fetch(images, {
        method: "GET",
      })
        .then((response) => response.blob())
        .then((blob) => {
          const source = URL.createObjectURL(blob);
          setprofileImage(source);
        })
        .catch((error) => console.error("Error fetching image:", error));
    } catch (Error) {
      console.log("Error", Error);
    }
  };

  const AdminConvertbase642 = async (image) => {
    try {
      let images =await GetPublicURL(image);
      fetch(images, {
        method: "GET",
      })
        .then((response) => response.blob())
        .then((blob) => {
          const source = URL.createObjectURL(blob);
          setCharmanSignature(source);
        })
        .catch((error) => console.error("Error fetching image:", error));
    } catch (Error) {
      console.log("Error", Error);
    }
  };
  const handlePrint = () => {
    // Find and hide the button
    const buttonToHide = document.querySelector(".hide-on-print");
    if (buttonToHide) buttonToHide.style.display = "none";

    // Print the content
    window.print();

    // Restore the button after printing
    if (buttonToHide) buttonToHide.style.display = "block";
  };

  return (
    <Grid
      item
      lg={12}
      style={{ padding: 50,backgroundColor:"#fff"  }}
      md={12}
      sm={12}
      xs={12}
      className="m-10"
    >
      <Grid item lg={8} ref={targetRef} md={8} sm={8} xs={8} className="px-3 ">
        <Grid
          item
          lg={12}
          sm={12}
          md={12}
          xs={12}
          container
          className=""
          border={"1px solid #666666"}
        >
          <Grid
            item
            lg={12}
            sm={12}
            md={12}
            xs={12}
            container
            className="p-3"
            borderBottom={"1px solid #666666"}
          >
            <Grid
              item
              lg={2}
              sm={4}
              md={4}
              xs={4}
              container
              justifyContent={"center"}
            >
              <img
                src={PSCLogo}
                alt="PSCLogo"
                height={80}
                width={80}
                className="img_fluid"
              />
            </Grid>
            <Grid
              item
              lg={10}
              sm={8}
              md={8}
              xs={8}
              container
              alignItems={"center"}
              flexDirection={"column"}
            >
              <h4 className="poppinsSemiBold Text-Prime-Black my-1">
                Police Service Commission
              </h4>
              <p className="poppinsRegular Text-Prime-Gray">
                Corporate Headquarters, Plot 64, Cadastral Zone B16, Sector
                Centre B, Jabi, Abuja
              </p>
              <p className="poppinsRegular Text-Prime-Gray">
                Website: https://psc.gov.ng/
              </p>
            </Grid>
          </Grid>
          <Grid
            item
            lg={12}
            sm={12}
            md={12}
            xs={12}
            className="p-2"
            container
            justifyContent={"center"}
            borderBottom={"1px solid #666666"}
          >
            <p className="poppinsSemiBold text-black text-center">
              {" "}
              {LetterHeading} for the Post {postName} for the year{" "}
              {"2024 - 2025"}
            </p>
          </Grid>
          <Grid item lg={12} sm={12} md={12} xs={12} container>
            <table style={{ width: "100%" }}>
              <tr>
                <td style={{ borderBottom: "1px solid #666666" }}>
                  <p className="poppinsSemiBold text-black text-left px-2 ">
                    Register No:
                  </p>
                  <p className="poppinsRegular text-black text-left fontSize12 px-2 ">
                    {applicationDetail?.application_serial
                      ? applicationDetail.application_serial
                      : "--"}
                  </p>
                </td>
                <td
                  style={{
                    borderLeft: "1px solid #666666",
                    borderBottom: "1px solid #666666",
                  }}
                >
                  <p className="poppinsSemiBold text-black text-left px-2 ">
                    Test Date & Time
                  </p>
                  {callLetterName == "Physical" ? (
                    <p className="poppinsRegular text-black text-left pt-1 px-2  fontSize12">

                      {applicationDetail?.physical_test_date? FormatDay(applicationDetail?.physical_test_date) +  ", " +formatDate(applicationDetail?.physical_test_date) : "--"}
                    </p>
                  ) : callLetterName == "Computer" ? (
                    <p className="poppinsRegular text-black text-left pt-1 px-2  fontSize12">

                      {applicationDetail?.computer_test_date? FormatDay(applicationDetail?.computer_test_date) +  ", " +formatDate(applicationDetail?.computer_test_date) : "--"}
                    </p>
                  ) : (
                    <p className="poppinsRegular text-black text-left pt-1 px-2  fontSize12">

                      {applicationDetail?.medical_test_date? FormatDay(applicationDetail?.medical_test_date) +  ", " +formatDate(applicationDetail?.medical_test_date) : "--"}
                    </p>
                  )}
                  <p className="poppinsRegular text-black text-left pt-1 px-2  fontSize12">
                    {ShiftDetails?.start_time  ? formatTimeRange(ShiftDetails?.start_time,ShiftDetails.duration) : "--"}
                  </p>
    
                </td>
                <th
                  align="center"
                  style={{
                    borderLeft: "1px solid #666666",
                    borderBottom: "1px solid #666666",
                  }}
                >
                  <Grid
                    item
                    container
                    justifyContent={"center"}
                    className="py-4"
                  >
                    <img
                      src={profileImage}
                      alt="Profile"
                      height={150}
                      width={150}
                      className="img_fluid"
                    />
                  </Grid>
                </th>
              </tr>
              <tr>
                <td style={{ borderBottom: "1px solid #666666" }}>
                  <p className="poppinsSemiBold text-black text-left px-2 ">
                    Name of the Applicant:
                  </p>
                  <p className="poppinsRegular text-black text-left px-2  fontSize12">
                    {CandidateDetail?.Title ? CandidateDetail?.Title : ""} .{" "}
                    {CandidateDetail?.Surname ? CandidateDetail?.Surname : ""}{" "}
                    {CandidateDetail?.LastName
                      ? CandidateDetail?.LastName
                      : "--"}
                  </p>
                </td>
                <td rowSpan="2" style={{ borderLeft: "1px solid #666666" }}>
                  <p className="poppinsSemiBold text-black text-left px-2 ">
                    Center Name:
                  </p>
                  <p className="poppinsRegular text-black text-left pt-1 px-2 fontSize12">
                    {CenterInformations?.center_name ? CenterInformations?.center_name: "--"}
                  </p>

                  <p className="poppinsSemiBold text-black text-left px-2 pt-2">
                    Venue Address:
                  </p>
                  <p className="poppinsRegular text-black text-left pt-1 px-2 fontSize12">
                    {CenterInformations?.center_address ? CenterInformations?.center_address: "--"}
                  </p>

                </td>
                <td
                  align="center"
                  style={{
                    borderLeft: "1px solid #666666",
                   
                  }}
                >

                </td>
              </tr>
              <tr>
                <td>
                  <p className="poppinsSemiBold text-black text-left px-2 ">
                    Next of Kin Name:
                  </p>
                  <p className="poppinsRegular text-black text-left  px-2 fontSize12">
                    {applicationDetail?.kin_details
                      ? applicationDetail?.kin_details[0]?.value +
                        " " +
                        applicationDetail?.kin_details[1]?.value
                      : "--"}
                  </p>
                </td>
                <td align="center" style={{ borderLeft: "1px solid #666666" }}>
                  <Grid item className="py-4">
                    <p className="poppinsSemiBold text-black mx-2">
                      Application Number
                    </p>
                    <p className="poppinsRegular text-black mx-2 fontSize12">
                      {applicationDetail?.application_serial
                        ? applicationDetail?.application_serial
                        : "--"}
                    </p>
                  </Grid>
                </td>
              </tr>
            </table>
          </Grid>
        </Grid>
        <Grid item lg={12} sm={12} md={12} xs={12} container>
          <div style={{ marginTop: 10 }}>
            <h3 style={{ alignItems: "flex-start" }} className="text-left ">
              <strong>Instructions for the Candidate:</strong>
            </h3>
            <p></p>

            <p className="text-left ">
              <strong>1. Arrival:</strong>
            </p>
            <ul>
              <li className="text-left ">
                Candidates are required to arrive at least [X] minutes before
                the test start time. Latecomers will not be allowed to
                participate in the test.
              </li>
            </ul>

            <p className="text-left ">
              <strong>2. Documents Required:</strong>
            </p>
            <ul className="text-left ">
              <li>A printed copy of this call letter (mandatory).</li>
              <li>
                A valid photo ID (NIN card, passport, or driver’s license).
              </li>
              <li>
                Relevant documents based on the test type (e.g., medical reports
                for the medical examination, sports gear for the physical test,
                etc.).
              </li>
            </ul>

            <p className="text-left ">
              <strong>3. Test Guidelines:</strong>
            </p>
            <ul className="text-left ">
              <li>
                Ensure you follow the instructions provided by the test
                officials during the session.
              </li>
              <li>
                For the physical test, wear appropriate sports attire and shoes.
              </li>
              <li>
                For the Computer-Based Test, you will be provided with a system
                to take the test. Bring a pen/pencil for rough work if needed.
              </li>
              <li>
                For the medical examination, provide any prior medical reports
                as requested.
              </li>
            </ul>

            <p className="text-left ">
              <strong>4. Health &amp; Safety:</strong>
            </p>
            <ul className="text-left ">
              <li>
                Candidates are advised to follow the COVID-19 health protocols (if
                applicable). Wear a mask and maintain social distancing.
              </li>
            
            </ul>

            <p className="text-left ">
              <strong>5. Disqualification:</strong>
            </p>
            <ul className="text-left ">
              <li>
              Failure to bring the required documents or non-compliance with the
              instructions will lead to disqualification from the recruitment
              process.
              </li>
            
            </ul>

          </div>

        </Grid>
        <Grid
          item
          lg={12}
          sm={12}
          md={12}
          xs={12}
          container
          className="p-3"
          justifyContent={"flex-end"}
        >
          <Grid
            item
            lg={3}
            sm={3}
            md={3}
            xs={3}
            container
            flexDirection={"column"}
            alignItems={"center"}
          >
            <p className="poppinsRegular Text-Prime-Black pb-2 text-center">
              With Regards,
            </p>
            <img
              src={CharmanSignature}
              alt="Signature"
              height={80}
              width={160}
              className="img_fluid"
            />
            <p className="poppinsSemiBold text-black text-center">
              {CharmanName}
            </p>
          </Grid>
        </Grid>
        <Grid
          item
          lg={12}
          sm={12}
          md={12}
          xs={12}
          container
          className="p-3"
          justifyContent={"center"}
        >
          <Grid
            item
            lg={3}
            sm={3}
            md={3}
            xs={3}
            container
            flexDirection={"column"}
            alignItems={"center"}
          >
            <GreenColorButton
              type="submit"
              className="hide-on-print px-3 py-2 ml-3"
              onClick={() => handlePrint()}
            >
              print
            </GreenColorButton>
          </Grid>
        </Grid>
      </Grid>
      <LoaderModal ShowLoader={ShowLoader} setShowLoader={setShowLoader} />
    </Grid>
  );
};

export default CallLetterView;
